export default __webpack_public_path__ + "static/media/logoPA.b6e673ed.png";